import React, { useState, useEffect } from 'react';
import '../../Marketing/BuisnessDashboard/Dashboard.scss';
import Sidebar from './components/Sidebar';
import MainContent from './MainContent';

export default function NachManagementMain({admin,allStatus,pageViewHandler}) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 1800 ? true : false);
    const [activeTab, setActiveTab] = useState("dashboard");
    const [activeSubTab, setActiveSubTab] = useState("")
    const [status,setStatus] =useState([])

    const handleTabType = (value, type) => {
        if (type == "activeTab") {
            setActiveTab(value?.ShowType)
            setActiveSubTab(value?.subType?.[0]?.ShowType)
        } else if (type == "activeSubTab") {
            setActiveSubTab(value)
        }
    }

    const handleBack=(e)=>{
        pageViewHandler(e,"landingPage")
    }



    return (
        <div className="Main-dashboard">
            <div className={`dashboard-sidebar ${isSidebarOpen ? "open" : ""}`}
                onMouseEnter={() => {window.innerWidth > 1800 ? null : setIsSidebarOpen(true)}}
                onMouseLeave={() => {window.innerWidth > 1800 ? null : setIsSidebarOpen(false)}}
            >
                <Sidebar
                    handleTabType={handleTabType}
                    isSidebarOpen={isSidebarOpen}
                    activeSubTab={activeSubTab}
                    activeTab={activeTab}
                />
            </div>

            <div className={`dashboard-main-content ${isSidebarOpen ? "open" : ""}`} style={{ padding: window.innerWidth > 1800 ? "20px 40px" : "20px",overflow:'auto' }}>
                <MainContent
                    activeSubTab={activeSubTab}
                    activeTab={activeTab}
                    status={status}
                    admin={admin} allStatus={allStatus}
                    handleBack={handleBack}
                />
            </div>
        </div>
    );
}
